import { render, staticRenderFns } from "./GlobalFloatingButtons.vue?vue&type=template&id=036f5dae&scoped=true"
import script from "./GlobalFloatingButtons.vue?vue&type=script&lang=js"
export * from "./GlobalFloatingButtons.vue?vue&type=script&lang=js"
import style0 from "./GlobalFloatingButtons.vue?vue&type=style&index=0&id=036f5dae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "036f5dae",
  null
  
)

export default component.exports